import { useEffect, useState } from "react";
import { GlobalRequest } from "../../../../../../../common/services/request";
import { Loader } from "../../../../../../../common/components/Loader/Loader";
import { HttpStatusCode } from "axios";
import { PointingDetailsContext } from "../../../../../core/_context";
import { VehicleDetailsData } from "./VehicleDetailsData";

type PropsType = {
  initialValue?: any;
};

export const VehicleDetails = ({ initialValue }: PropsType) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [initialState, setInitialState] = useState<any>();

  useEffect(() => {
    if (initialValue) {
      getVehicle(initialValue?.["@id"]);
    }
  }, [initialValue]);

  const getVehicle = async (url: string) => {
    try {
      setIsLoading(true);
      const res = await GlobalRequest.get(`${url}/controlled`);

      if (res?.status === HttpStatusCode.Ok) {
        setInitialState(res?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <PointingDetailsContext.Provider
      value={{
        data: initialState,
      }}
    >
      <Loader isLoading={isLoading} />
      {/* <Tabs items={TAB_ITEMS} /> */}
      <VehicleDetailsData />
    </PointingDetailsContext.Provider>
  );
};
